import type { EnumLiteral } from '../../uiModels/enumLiterals/types'

export type EnumElementSelection =
  | { variant: 'definition' }
  | { variant: 'literal'; value: string }

export const AddLiteralPlaceholder = Symbol('AddLiteralPlaceholder')

export const isAddLiteralPlaceholder = (
  data: EnumLiteral | typeof AddLiteralPlaceholder,
): data is typeof AddLiteralPlaceholder => data === AddLiteralPlaceholder
